module.exports = __webpack_public_path__ + "static/media/MICHELL TECNODEC.035b59a3.png";